import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import Axios from "../../api/Axios";
import storage from "../../Services/Storage";
import * as Fa from "react-icons/fa";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { toast } from "react-toastify";

const CSDCustDistCodeURL = "GRN/GetCSDCustDistCode?";
const PaymetLinkURL = "GRN/GetMintifiURL?";
const GetMintifiTAGURL = "GRN/GetMintifiTAG?";
const UpdateMintifiTAGURL = "GRN/UpdateMintifiTAG?";

const GetFinancialAssistance = () => {
    const auth = storage.getLocal("user");
    const [csdData, setCsdData] = useState();
    const [mintifiTag, setMintifiTag] = useState("N");
    const [checked, setChecked] = useState(false);
    const [visible, setVisible] = useState(false);
    const [alertVisible, setAlertVisible] = useState(false);
    const getMintifiURL = async () => {
        try {
            const res = await Axios.get(
                `${PaymetLinkURL}Cust_Code=${csdData.CUST_CODE}&Anchor_Code=${csdData.DIST_ID}`
            );
            console.log(res,"getMintifiURL");
            handelRedirect(res.data.data.link);
            UpdateMintifiTAG("Y");
        } catch (ex) {
            setAlertVisible(true);
            console.log(ex, "GetFinancialAssistance");
        }
    };
    const GetCSDCustDistCode = async () => {
        try {
            const GRN_urls = `${CSDCustDistCodeURL}CompId=${auth.CompId}`;
            const response = await Axios.get(GRN_urls);
            setCsdData(response.data[0]);
        } catch (ex) {
            console.log(ex, "GetCSDCustDistCode");
        }
    };
    const GetMintifiTAG = async () => {
        try {
            const url = `${GetMintifiTAGURL}CompId=${auth.CompId}`;
            const res = await Axios.get(url);
            console.log(res.data.Data[0].TAG, "GetMintifiTAG");
            setMintifiTag(res.data.Data[0].TAG);
        } catch (ex) {
            console.log(ex, "GetMintifiTAG");
        }
    };
    const UpdateMintifiTAG = async (isOnboard) => {
        try {
            const url = `${UpdateMintifiTAGURL}CompId=${auth.CompId}&UserId=${auth.UserId}&IsOnboard=${isOnboard}`;
            const res = await Axios.get(url);
            console.log(res, "UpdateMintifiTAG");
            setVisible(false);
            setChecked(false);
            if (isOnboard === "NA") {
                toast.success(
                    res.data.Message,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    }

                );
            }
            GetMintifiTAG();
        } catch (ex) {
            console.log(ex, "UpdateMintifiTAG");
            setVisible(false);
        }
    };
    const handelRedirect = (link) => {
        window.open(link, "_blank");
    };
    useEffect(() => {
        GetCSDCustDistCode();
        GetMintifiTAG();
    }, []);

    
    const footerContent = (
        <div>
            <div className="text-end">
                <button
                    type="button"
                    className="btn btn-primary me-2"
                    onClick={() => UpdateMintifiTAG("NA")}
                    disabled={!checked}
                >
                    Accept <Fa.FaCheck className="ms-2" />
                </button>
                <button
                    type="button"
                    className="btn btn-cancel-red"
                    onClick={() => UpdateMintifiTAG("N")}
                >
                    Decline <Fa.FaTimes className="ms-2" />
                </button>
            </div>
        </div>
    );

    const footerContent1 = (
        <div>
            <div className="text-end">
                <button type="button" className="btn btn-cancel-red" onClick={()=>setAlertVisible(false)}>Close</button>
            </div>
        </div>
    );

    return (
        <main>
            <div className="col-12 pt-3 pb-3">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Get Financial Assistance</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12"></div>
                </div>
                <section className="sales-box">
                    <div className="">
                        <div className="row d-flex justify-content-center align-items-center">

                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <img
                                    src={require("../../Assets/Images/priceList.png")}
                                    style={{ width: "100%" }}
                                />
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                {mintifiTag === "Y" || mintifiTag === "NA"? (
                                    <div className="panel">
                                        <p style={{ fontSize: "16px" }} className="mb-0">
                                            Click to Get Financial Assistance
                                        </p>
                                        <Fa.FaHandPointRight className="text-success" />{" "}
                                        <img
                                            src={require("../../Assets/Images/mintifi.png")}
                                            style={{ width: "120px", cursor: "pointer" }}
                                            onClick={() => getMintifiURL()}
                                        />
                                    </div>):mintifiTag==="N"?(
                                    <div className="panel">
                                        <p style={{ fontSize: "16px" }} className="mb-0">
                                            Click to Onboard Yourself to  <img src={require("../../Assets/Images/mintifi.png")} style={{ width: "70px" }} />
                                        </p>
                                        <button
                                            type="submit"
                                            className="btn btn-primary mt-2"
                                            onClick={() => setVisible(true)}
                                        >
                                            Onboard
                                        </button>
                                    </div>):(
                                    <div className="panel">
                                        <p style={{ fontSize: "16px" }} className="mb-0 text-danger"><b><i>You are not on-boarded to any financial site</i></b>
                                        </p>
                                    </div>)}
                            </div>
                            
                        </div>
                    </div>
                </section>
            </div>

            <Dialog
                header="Terms and Condition"
                style={{ width: "50vw" }}
                closable={false}
                draggable={false}
                visible={visible}
                onHide={() => setVisible(false)}
                resizable={false}
                footer={footerContent}
            >
                <div className="sales-box">
                    <p className="m-0 text-center">
                        <b>Disclaimer:</b> By clicking, you agree that your contact
                        information (such as name, phone number, email address, pending
                        invoices) etc, may be shared with Mintifi, for enabling you to
                        access their platform for availing finance options & making
                        payments. Once your information is shared with Mintifi, they will
                        store and process it as per their privacy policy available at{" "}
                        <a
                            href="https://www.mintifi.com/privacy_policy"
                            target="_blank"
                            className="text-success" rel="noreferrer"
                        >
                            Mintifi
                        </a>
                    </p>
                </div>

                <div className="d-flex justify-content-start align-items-center">
                    <Checkbox onChange={e => setChecked(e.checked)} checked={checked} style={{ width: "28px", height: "18px" }} />
                    <small className="d-inline-block"><label htmlFor="Accept" className="me-2">
                        I accept the terms and conditions
                    </label>
                    </small>
                </div>
            </Dialog>


            <Dialog
                header="Information"
                style={{ width: "40vw" }}
                closable={false}
                draggable={false}
                visible={alertVisible}
                onHide={() => setAlertVisible(false)}
                resizable={false}
                footer={footerContent1}
            >
                <div className="text-center">
                    <Fa.FaInfoCircle className="text-danger mb-3" style={{ fontSize: "40px", opacity: "0.8" }} />
                    <p className="m-0 text-center">You are still not onboarded in <img src={require("../../Assets/Images/mintifi.png")} style={{ width: "60px" }} /> website</p>
                </div>
            </Dialog>
        </main>
    );
};

export default GetFinancialAssistance;
